// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ContatosFidelizacao_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /contatos_fidelizacao/delete
 *
 * Returns an empty success response after deleting a loyalty contact.
 * The delete operation is successful if the record is removed.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ContatosFidelizacao_DeleteResponseDados = string;

export type ContatosFidelizacao_DeleteResponse = ApiResponse<ContatosFidelizacao_DeleteResponseDados>;

registerResponseContract('ContatosFidelizacao_DeleteResponse', {})
